#import "./cartFragment.gql"

mutation updateBuyerIdentityMutation($buyerIdentity: CartBuyerIdentityInput!, $id: ID!, $lang: LanguageCode!)
@inContext(language: $lang) {
  cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $id) {
    cart {
      ...cartFragment
    }
    userErrors {
      field
      message
    }
  }
}
